import React, { Component } from 'react'

export default class ScrollTop extends Component{

	constructor(props){
		super(props)
		this.state = { visible: false }
	}

	scrollToTop(){
		if (typeof window !== 'undefined') {
			// Faire défiler vers le haut
			window.scroll(0, 0)
			
			// Déplacer le focus vers l'élément principal en haut de page pour l'accessibilité
			// Utiliser setTimeout pour s'assurer que le scroll est terminé
			setTimeout(() => {
				const mainContent = document.getElementById('main-content')
				if (mainContent) {
					// Rendre l'élément focusable temporairement si nécessaire
					const originalTabIndex = mainContent.getAttribute('tabindex')
					if (!originalTabIndex) {
						mainContent.setAttribute('tabindex', '-1')
					}
					mainContent.focus()
					// Retirer le tabindex après le focus pour éviter qu'il soit dans l'ordre de tabulation
					if (!originalTabIndex) {
						mainContent.removeAttribute('tabindex')
					}
				} else {
					// Fallback : chercher le header ou le premier élément focusable
					const header = document.querySelector('header')
					if (header) {
						const originalTabIndex = header.getAttribute('tabindex')
						if (!originalTabIndex) {
							header.setAttribute('tabindex', '-1')
						}
						header.focus()
						if (!originalTabIndex) {
							header.removeAttribute('tabindex')
						}
					}
				}
			}, 100)
		}
	}

	handleKeyDown = (event) => {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault()
			this.scrollToTop()
		}
	}

	fireOnScroll = (event) => {
    	if (typeof window !== 'undefined') {
	    	if(window.scrollY > 50){
	    		this.setState({visible: true})
	    	}
	    	else
	    		this.setState({visible: false})
	    }
	}

	componentDidMount() {
		if (typeof window !== 'undefined') {
	    	window.addEventListener('scroll', this.fireOnScroll)
	    }
	}

	componentWillUnmount() {
		if (typeof window !== 'undefined') {
	    	window.removeEventListener('scroll', this.fireOnScroll)
	    }
	}

	render(){
		return(
			<nav 
				className="scrolltop-container" 
				role="navigation" 
				aria-label="Retour en haut de page"
			>
				<button
					type="button"
					className={`scrolltop-button ${(this.state.visible ? "visible" : "hidden")}`}
					onClick={this.scrollToTop}
					onKeyDown={this.handleKeyDown}
					aria-label="Retour en haut de la page"
					title="Retour en haut de la page"
				>
					<span className="scrolltop-text">
						Haut de page
					</span>
					<span className="scrolltop-icon" aria-hidden="true">
						↑
					</span>
				</button>
			</nav>
		)
	}
}